/* eslint-disable jsx-a11y/tabindex-no-positive */
import { css } from '@emotion/react';
import React from 'react';

import Form from '@/src/shared/components/Form';

import HeaderSection from '../HeaderSection';
import StickyFooter from '../StickyFooter';
import SubmitButton from '../SubmitButton';
import FormFields from './FormFields';

const styles = {
  formContainer: css`
    padding: 2.6rem 2.4rem 0 2.4rem;
  `,
};

function UpdateProfileForm({ form, fieldInfo, updateProfile, roles }) {
  console.log('I am fieldIndo in update profile form', fieldInfo);
  return (
    <Form>
      <div css={styles.formContainer}>
        <HeaderSection headerText="Update Profile" />
        <div css={styles.mainContentContainer}>
          <FormFields form={form} fields={fieldInfo} updateProfile={updateProfile} roles={roles} />
          <StickyFooter>
            <SubmitButton form={form} updateProfile={updateProfile} roles={roles} fieldInfo={fieldInfo}/>
          </StickyFooter>
        </div>
      </div>
    </Form>
  );
}

export default Form.create({ name: 'updateProfileForm' })(UpdateProfileForm);
